export const FORM_CREATE_ROUTE = '/create';
export const FORM_PLAYGROUND_ROUTE = '/form-playground';

// Routes where social/OG metadata should be suppressed (internal app pages not meant for link previews)
export const NO_SOCIAL_PREVIEW_ROUTES = ['/forms/:id/edit', '/forms/:id/responses'];
